import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureUtm } from "@/lib/utm";
import { trackPageView } from "@/lib/analytics";

/**
 * Pixel + GA4 are injected synchronously in /app/frontend/src/index.js
 * before React mounts. This component only handles:
 *   • UTM capture (once on mount, and on route change for safety)
 *   • PageView event on every client-side navigation
 */
export default function Analytics() {
  const location = useLocation();

  useEffect(() => {
    captureUtm();
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}
